export default function AboutSection() {
  return (
    <section id="about" className="py-28 md:py-36 bg-[#f8f9fa]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20 items-start">
          {/* Left */}
          <div className="lg:w-2/5">
            <p className="text-[#00d4aa] text-xs font-bold tracking-[4px] uppercase mb-4">Who We Are</p>
            <h2 className="text-5xl md:text-6xl font-black text-gray-900 leading-tight mb-6">
              Expertise
              <br />
              <span className="font-light text-gray-500">&amp; Innovation</span>
            </h2>
            <p className="text-gray-600 text-base leading-relaxed">
              AKIAN DOO is a dedicated team of developers and security specialists committed to building
              applications that make a real difference in how people use their mobile devices.
            </p>
          </div>

          {/* Right */}
          <div className="lg:w-3/5 grid grid-cols-1 sm:grid-cols-2 gap-6">
            {/* Card 1 */}
            <div className="bg-white rounded-2xl overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/5baee0d4daf02fd9874c8ff9de00c3b4.jpg"
                alt="Security expertise"
                className="w-full h-48 object-cover object-top"
              />
              <div className="p-5">
                <h3 className="font-bold text-gray-900 text-base mb-1">Security Expertise</h3>
                <p className="text-gray-500 text-sm leading-relaxed">
                  Deep knowledge in mobile security, encryption, and privacy protection for iOS users.
                </p>
              </div>
            </div>

            {/* Card 2 */}
            <div className="bg-white rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=iOS%20app%20development%20workspace%20with%20code%20on%20screen%2C%20clean%20modern%20office%20setup%2C%20teal%20accent%20lighting%2C%20professional%20developer%20environment%2C%20minimal%20aesthetic&width=600&height=400&seq=about002&orientation=landscape"
                alt="iOS Development"
                className="w-full h-48 object-cover object-top"
              />
              <div className="p-5">
                <h3 className="font-bold text-gray-900 text-base mb-1">App Development</h3>
                <p className="text-gray-500 text-sm leading-relaxed">
                  Specialized in native mobile development with a focus on performance and user experience.
                </p>
              </div>
            </div>

            {/* Card 3 */}
            <div className="bg-white rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=mobile%20app%20performance%20optimization%20concept%2C%20speed%20and%20efficiency%20visualization%2C%20abstract%20flowing%20lines%20on%20dark%20background%2C%20teal%20and%20white%20color%20scheme%2C%20modern%20digital%20art&width=600&height=400&seq=about003&orientation=landscape"
                alt="Performance"
                className="w-full h-48 object-cover object-top"
              />
              <div className="p-5">
                <h3 className="font-bold text-gray-900 text-base mb-1">Performance Driven</h3>
                <p className="text-gray-500 text-sm leading-relaxed">
                  Every product is optimized for speed, battery efficiency, and smooth operation.
                </p>
              </div>
            </div>

            {/* Card 4 */}
            <div className="bg-white rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=user%20experience%20design%20for%20mobile%20apps%2C%20clean%20UI%20wireframes%20and%20prototypes%2C%20minimal%20white%20and%20teal%20color%20palette%2C%20professional%20design%20studio%20aesthetic%2C%20modern%20flat%20design&width=600&height=400&seq=about004&orientation=landscape"
                alt="User Experience"
                className="w-full h-48 object-cover object-top"
              />
              <div className="p-5">
                <h3 className="font-bold text-gray-900 text-base mb-1">User-Centered Design</h3>
                <p className="text-gray-500 text-sm leading-relaxed">
                  Intuitive interfaces that make complex security features accessible to everyone.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Values Row */}
        <div className="mt-20 grid grid-cols-1 sm:grid-cols-3 gap-8 border-t border-gray-200 pt-16">
          {[
            { icon: 'ri-shield-check-line', title: 'Privacy First', desc: 'We build with a zero-compromise approach to user privacy and data security.' },
            { icon: 'ri-smartphone-line', title: 'Mobile First', desc: 'Purpose-built for mobile ecosystems, delivering powerful and smooth experiences.' },
            { icon: 'ri-team-line', title: 'Expert Team', desc: 'A passionate team of specialists with years of mobile development experience.' },
          ].map((item) => (
            <div key={item.title} className="flex gap-4 items-start">
              <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-[#00d4aa]/10 shrink-0">
                <i className={`${item.icon} text-[#00d4aa] text-xl`} />
              </div>
              <div>
                <h4 className="font-bold text-gray-900 text-sm mb-1">{item.title}</h4>
                <p className="text-gray-500 text-sm leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
